// extracted by mini-css-extract-plugin
export default {"property":"nb_lq","item":"HV81q","itemActive":"gJzwJ","itemIcon":"fxD84"};